import api from '@/api/fetch'
import type { CouriersReport } from '@/types'

export function getCourierReport() {
  return api.get<CouriersReport>('/reports/couriers').then(res => res.data)
}

export function resetCourierReport(courierId: string) {
  return api.post(`/reports/courier/${courierId}/reset`, {}).then(res => res.data)
}
